var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['user-layout-wrapper', _vm.isMobile && 'mobile'],attrs:{"id":"userLayout"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"user-layout-content"},[_vm._m(0),_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"/"}},[_c('span',{staticClass:"title"},[_vm._v("正红老年人能力评估系统")])])])])
}]

export { render, staticRenderFns }